// src/whitelabel/tenants.js
const tenants = {
  default: {
    name: "Default App",
    logo: "/whitelabel/logo/c-sharp.png",
    primaryColor: "#007bff",
  },
  clienty: {
    name: "Client Y",
    logo: "/whitelabel/logo/CJ_logo.png",
    primaryColor: "#eb0254",
  },
  clientx: {
    name: "Client X",
    logo: "/whitelabel/logo/chat-gpt.png",
    primaryColor: "#25a18e",
  },
};

export default tenants;
